export enum RoleEnum {
	Admin = 'Admin',
	Reseller = 'Reseller',
	Master = 'Master',
	Manager = 'Manager',
}

export default RoleEnum;
